module.exports = __webpack_public_path__ + "img/icon_add-photo.461b689e.svg";